// SELECT-only readback of one job's POs: staging rows (po_created / reject_comments) + live PO_Sub_H.
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function FoundationPOReadbackDialog({ row, data, onClose }) {
  const mine = (data.pos || []).filter((p) => p.po_no === row.foundation_no || p.po_no === row.number);
  const list = mine.length ? mine : (data.pos || []);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="foundation-po-readback-dialog">
        <DialogHeader>
          <DialogTitle className="text-base">Foundation readback — job {data.job_no} ({data.database})</DialogTitle>
          <DialogDescription className="text-xs">SELECT-only: staging rows + live PO tables for every PO of this job.{mine.length ? "" : " Showing all POs on the job."}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {list.length === 0 && <div className="text-xs text-slate-400">Nothing in staging or live for this job.</div>}
          {list.map((p) => (
            <div key={p.po_no} className="rounded border border-slate-200 dark:border-slate-700 p-2 text-xs" data-testid={`readback-po-${p.po_no}`}>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-mono font-semibold">{p.po_no}</span>
                {p.serviceops_po_number && p.serviceops_po_number !== p.po_no && <span className="text-slate-500">(ServiceOps {p.serviceops_po_number})</span>}
                <span className={`px-1.5 py-0.5 rounded-full text-[10px] ${p.live_exists ? "bg-emerald-100 text-emerald-800" : p.deleted_in_po_sync ? "bg-slate-200 text-slate-600" : "bg-amber-100 text-amber-800"}`}>{p.status}</span>
              </div>
              {p.staging_header && (
                <div className="mt-1 text-slate-600 dark:text-slate-300">
                  staging: created {p.po_created || "—"} · status {p.staging_header.record_status} · desc “{p.staging_header.po_description || ""}” · format {p.staging_header.po_format} · user {String(p.staging_header.md_user || "").trim() || "NULL"} · items {p.staging_details?.length || 0}
                  {p.reject_comments ? <div className="text-rose-700">reject: {p.reject_comments}</div> : null}
                </div>
              )}
              {p.live_header && <div className="mt-1 text-emerald-700">live PO_Sub_H: {p.live_header.Description} · {p.live_lines?.length || 0} line(s)</div>}
            </div>
          ))}
          {Object.keys(data.errors || {}).length > 0 && <pre className="text-[10px] text-rose-700 whitespace-pre-wrap">{JSON.stringify(data.errors, null, 1)}</pre>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
